import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterLeftPadd"
    ,pure: false
})
export class FilterLeftPadd implements PipeTransform {
    transform(inputValue:any,size:number):any {
        if(!inputValue){
            return inputValue;
        }
        if(!size){
            size = 0;
        }

        inputValue = inputValue + '';
        return inputValue.length >= size ? inputValue : new Array(size - inputValue.length + 1).join('0') + inputValue;
    }
}
